import React from 'react'

import commaSeparetedValue from '../../../../../helpers/commaSeparetedValue'
import Image from './Image'
import Details from './Details'
import Quantity from './Quantity'
import VehicleFitment from './VehicleFitment'
import RemoveFromCart from './RemoveFromCart'
import DeliveryDates from './Details/DeliveryDates'
import FreeShippingBadge from './FreeShippingBadge'
import InstallAtShopWrapperCart from '../../../../DIFM/InstallAtShop/InstallAtShopWrapperCart'
import {
  StyledImageAndDetails,
  StyledImageContainer,
  StyledMobileContainer,
  StyledQuantityPrice,
  StyledWidgetsContainer,
} from './ItemMobileWmo.css'
import Core from './Details/Core'
import { StyledPrice } from './ItemDesktopWmo.css'
import ProductProtection from './ProductProtection/ProductProtection'
import { FreeShippingBadgeV2 } from '../../../../FreeShippingBadge/FreeShippingBadgeV2'
import { PromoBadge } from '../../../../PromoBadge'
import { ItemLoader } from './ItemLoader'

const ItemMobileWmo = ({
  data,
  index,
  itemTotal,
  handleAddVehicle,
  lastSkuEta,
  trackSelectItem,
  promoBadgeConfig,
  isPromoBadgeEnabled,
  showLoader,
  isFitmentVisible,
}) => (
  <StyledMobileContainer>
    <ItemLoader
      showLoader={showLoader}
      currentItemProductId={data?.product?.productId}
    />
    <DeliveryDates data={data} />

    <StyledImageAndDetails>
      <StyledImageContainer>
        {(!isPromoBadgeEnabled) && (
          <FreeShippingBadge data={data} />
        )}
        <Image data={data} trackSelectItem={trackSelectItem} />
        {(isPromoBadgeEnabled) && (
          <FreeShippingBadgeV2 data={data} />
        )}
        {(isPromoBadgeEnabled && data?.product?.pricingStatus?.isPromo) && (
          <PromoBadge data={{ pageType: 'cart', sku: data?.product?.sku }} config={promoBadgeConfig} />
        )}
      </StyledImageContainer>
      <div>
        <Details data={data} index={index} trackSelectItem={trackSelectItem} />
        <Core data={data} index={index} />
      </div>
    </StyledImageAndDetails>

    <StyledWidgetsContainer>
      {isFitmentVisible && <VehicleFitment data={data} />}
      {(data?.productWarranty && data?.productWarranty?.productProtectionPlan.length > 0) && (
        <ProductProtection data={data} />
      )}
      <InstallAtShopWrapperCart
        cartItemData={data}
        addVehicleTrigger={handleAddVehicle}
        lastSkuEta={lastSkuEta}
      />
    </StyledWidgetsContainer>

    <StyledQuantityPrice>
      <Quantity data={data} index={index} />
      <StyledPrice>
        $
        {commaSeparetedValue(itemTotal)}
      </StyledPrice>
    </StyledQuantityPrice>

    <RemoveFromCart data={data} index={index} />
  </StyledMobileContainer>
)

export default ItemMobileWmo
